// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 915) return "915.88c7ec80e35f3f638629.css";
	if (chunkId === 126) return "126.37b16a896c89ba39ce63.css";
	// return url for filenames based on template
	return undefined;
};